import PeriodDrop from "./PeriodDrop";

export default function Card({ title, Icon, iBg, iC, badge, period, onPeriod, showRange, rangeFrom, rangeTo, onRangeFrom, onRangeTo, children }) {
  return (
    <div className="bg-white rounded-[14px] border border-[#E8ECF0] shadow-[0_1px_8px_rgba(0,0,0,.05)] p-5">
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-2 text-[13px] font-bold text-[#1E293B]">
          <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0" style={{ background: iBg }}>
            <Icon size={13} color={iC} />
          </div>
          {title}
        </div>

        <div className="flex items-center gap-2">
          {badge}
          {onPeriod && <PeriodDrop value={period} onChange={onPeriod} color={iC} />}
        </div>
      </div>
      {showRange && (
        <div className="flex gap-2 mb-2.5 items-center">
          <input type="date" value={rangeFrom} onChange={e => onRangeFrom(e.target.value)}
            className="flex-1 text-[10px] px-2 py-[5px] rounded-lg outline-none font-[inherit] text-[#64748B]"
            style={{ border: `1.5px solid ${iC}30` }} />
          <span className="text-[11px] text-[#94A3B8]">→</span>
          <input type="date" value={rangeTo} onChange={e => onRangeTo(e.target.value)}
            className="flex-1 text-[10px] px-2 py-[5px] rounded-lg outline-none font-[inherit] text-[#64748B]"
            style={{ border: `1.5px solid ${iC}30` }} />
        </div>
      )}
      <div className={showRange ? "" : "mt-2"}>{children}</div>
    </div>
  );
}
